export default "__VITE_ASSET__B0Pee_YY__"